// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "LeftNavWrapper-module--cds--assistive-text--32c55";
export var cdsVisuallyHidden = "LeftNavWrapper-module--cds--visually-hidden--db054";
export var expanded = "LeftNavWrapper-module--expanded--93620";
export var hideFeedback = "LeftNavWrapper-module--hide-feedback--75317";
export var leftNavWrapper = "LeftNavWrapper-module--leftNavWrapper--8a1ec";
export var showFeedback = "LeftNavWrapper-module--show-feedback--ae9ab";
export var skeleton = "LeftNavWrapper-module--skeleton--167f9";
export var useHeaderNavStyles = "LeftNavWrapper-module--useHeaderNavStyles--39ee3";